<template>
    <div>
        <div class="flex center-xs space-top-1 space-bottom-2">
            <div class="vertical-center input-container">
                <div class="start-xs full-width">
                    <label :for="step.name">{{ step.label }}</label>
                    <input @keyup.enter="keycheck" v-model.trim="inputData" v-focus class="full-width" ref="textInput"  type="text" :placeholder="step.placeholder">
                    <div v-if="inputValid" class="valid-check"></div>
                </div>
                <div class="full-width">
                    <div v-if="displayErrorMessage" class="red-text space-top-2">
                        {{step.errorMessage}}
                    </div>
                </div>
            </div>
        </div>

        <ButtonSection
          :inputValid="inputValid"
          :order="order"
          :buttonText="step.buttonText"
          v-on:progress="handleProgress"
          v-on:back="$emit('back')"
        />
    </div>
</template>

<script>
import debounce from 'lodash.debounce';
import { minLength, required } from 'vuelidate/lib/validators';

import ButtonSection from '../components/ButtonSection';


export default {
    props: ['step', 'order'],
    components: {
        ButtonSection
    },
    directives: {
        focus: {
            inserted: function (el) {
                el.focus()
            }
        }
    },
    data() {
        return {
            dirty: false
        }
    },
    validations: {
        inputData: {
            required,
            minLength: minLength(2)
        }
    },
    computed: {
        inputData: {
            get: function() {
                return this.$store.state.formFields[this.step.name];
            },
            set: debounce(function(value) {
                this.dirty = true;
                const name = this.step.name;
                this.$store.commit('updateField', { name, value })
            }, 400)
        },
        inputValid() {
            return !this.$v.inputData.$invalid;
        },
        displayErrorMessage() {
            return this.$v.inputData.$invalid && this.dirty;
        }
    },
    watch: {
        step: function() {
            // If there are two consecutive TextField, make sure dirty is reset
            this.dirty = false;
            this.$refs.textInput.focus();
        }
    },
    methods: {
        handleProgress(){
            this.$emit('progress', this.step.name);
        },
        keycheck(e) {
            if (e.keyCode === 13 && this.inputValid) {
                this.$emit('progress', this.step.name);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
input[type=text] {
    border: 3px solid #0384FB;
    box-sizing: border-box;
}
</style>
